/* eslint-disable import/prefer-default-export */
import { all, takeLatest, put } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import strings from '../../globalization';

export function* acknowledgeNotification({ payload }) {
  const startTime = new Date().getTime();
  try {
    console.info('acknowledgeNotification request', payload);
    const response = yield API.acknowledgeNotification(payload);
    console.info(
      ActionTypes.ACKNOWLEDGE_NOTIFICATION,
      'response time',
      new Date().getTime() - startTime,
      'response',
      response,
    );
    yield put({
      type: ActionTypes.ACKNOWLEDGE_NOTIFICATION_SUCCESS,
      payload: { ...response.data },
    });
  } catch (error) {
    console.warn('error acknowledgeNotification', error, 'error.response', error.response);

    let errorMessage = '';
    if (error.response) {
      errorMessage = error.response.data.message;
    } else if (error.message === 'Network Error') {
      errorMessage = strings.networkError;
    } else {
      errorMessage = error.message;
    }

    yield put({
      type: ActionTypes.ACKNOWLEDGE_NOTIFICATION_FAILURE,
      payload: errorMessage,
    });
  }
}

export default function* root(): any {
  yield all([takeLatest(ActionTypes.ACKNOWLEDGE_NOTIFICATION_REQUEST, acknowledgeNotification)]);
}
